import { TerminalApi } from '@/apis/terminal.aspi';
import { Terminal } from '@/models/terminal';
import { CheckCircleOutlined, DesktopOutlined, MoreOutlined, SyncOutlined, WifiOutlined } from '@ant-design/icons';
import { Button, Card, Col, Dropdown, DropdownProps, MenuProps, Row, Space, Spin, Tabs, TabsProps, Tag, Tooltip } from 'antd';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router-dom';
import BasicInformation from './basicInformation';
import './index.scss';
import AppFirmware from './firmwareList';
import DeviceLinking from './deviceLinking';
import LocationContext from './hook/locationContext';
import AuditLogs from './auditLog';
import AppList from './appList';
import './index.scss';
import ModalUpdateDevice from './modal/modalUpdateDevice';
import showNotification from '@/components/common/notification';
import showConfirmModal from '@/components/common/modal-confirm';
import { useRecoilValue } from 'recoil';
import { uiSettingState } from '@/states/uiSetting';
import { TerminalType } from '@/constants/app.enums';


function TerminalDetail1() {
  const location = useLocation();
  const { id } = useParams();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [termialData, setTerminalData] = useState<Terminal>();
  const [filteredItems, setFilteredItems] = useState<MenuProps['items']>([]);
  const [isModalDeviceOpen, setIsModalDeviceOpen] = useState(false);
  const locationData = useContext(LocationContext);
  const [open, setOpen] = useState(false);
  const uiSetting = useRecoilValue(uiSettingState);
  const allowEdit = uiSetting.isAllowAddDevice

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const { data } = await TerminalApi.getTerminalDetail(id ?? "");
      setTerminalData(data);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const items: TabsProps['items'] = [
    {
      key: 'basic-tab',
      label: <Row className="h6-semiBold">Basic Information</Row>,
      children: <BasicInformation terminal={termialData} />,
    },
    {
      key: 'firmware-tab',
      label: <Row className="h6-semiBold">Firmware List</Row>,
      children: <AppFirmware terminal={termialData} />,
    },
    {
      key: 'app-tab',
      label: <Row className="h6-semiBold">App List</Row>,
      children: <AppList terminal={termialData} />,
    },
    {
      key: 'push-tab',
      label: <Row className="h6-semiBold">Device Linking</Row>,
      children: <DeviceLinking terminal={termialData} />,
      destroyInactiveTabPane: true
    },
    {
      key: 'log-tab',
      label: <Row className="h6-semiBold">Audit Log</Row>,
      children: <AuditLogs terminal={termialData} />,
      destroyInactiveTabPane: true
    }
  ];

  const handleOpenChange: DropdownProps['onOpenChange'] = (nextOpen, info) => {
    if (info.source === 'trigger' || nextOpen) {
      setOpen(nextOpen);
    }
  };

  const handleEditDevice = () => {
    setIsModalDeviceOpen(true);
    setOpen(false);
  };

  const terminalMenu: MenuProps["items"] = [
    {
      key: "1",
      label: "Edit Device",
      onClick: handleEditDevice,
    },
  ];

  const handleCancelDeviceModal = (isUpdated?: boolean) => {
    setIsModalDeviceOpen(false);
    if (isUpdated) {
      fetchData();
    }
  };

  return (
    <Spin spinning={false} size='large'>
      <Card className="device-info-card">
        <Space className="card-body" direction="vertical" style={{ width: '100%' }}>
          <div className="header">
            <span className="device-id h5-semiBold">
              {termialData?.terminalSerialNumber} {termialData?.lszTerminalName && `- ${termialData.lszTerminalName}`}
            </span>
            <Space size="middle">
              <WifiOutlined className="icon" />
              <span className="status-text">66%</span>
              <DesktopOutlined className="icon" />
              <span className="status-text">Online</span>
              <Tag color={termialData?.isDeactivate ? "red" : "green"}>{termialData?.isDeactivate ? "Deactivate" : "Activate"}</Tag>
              {allowEdit && <Dropdown
                className="icon-detail"
                menu={{
                  items: terminalMenu
                }}
                placement="bottomRight"
                trigger={["click"]}
                open={open}
                onOpenChange={handleOpenChange}>
                <MoreOutlined />
              </Dropdown>
              }
            </Space>
          </div>
          <span className="info-text">
            Location: {termialData?.terminalLocation} / Merchant: {termialData?.merchantName} / Type: {termialData?.terminalType === TerminalType.Kiosk ? "Kiosk" : "Payment"} / Brand: {termialData?.brand} / Model: {termialData?.model}
          </span>
        </Space>
      </Card>
      <Tabs
        style={{ width: '100%' }}
        items={items}
        className="terminal-title"
        defaultActiveKey='terminal-list-tab'
      />
      <ModalUpdateDevice
        visible={isModalDeviceOpen}
        onClose={handleCancelDeviceModal}
        terminalData={termialData}
      />
    </Spin>
  );
}
export default TerminalDetail1;
